export enum TextAlignment {
  Left = 0,
  Center = 1,
  Right = 2,
}
